import React from "react";

import { CheckCircle } from "@hl/base-components/lib/assets/icons.generated";
import { UTILITY_COLOR } from "@hl/base-components/lib/theme/colors";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { DFSFallbackImage } from "@hl/shared-features/lib/features/image";
import { Box, Divider, Group, Stack, Text } from "@mantine/core";

const ItemGridTile = ({
  isSelected,
  onSelect,
  imageUrl,
  title,
  subtitle,
}: {
  isSelected: boolean;
  onSelect: () => void;
  imageUrl?: string;
  title: string;
  subtitle?: string;
}) => {
  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.colors.divider[0]}`,
        outline: isSelected ? `2px solid ${theme.primaryColor}` : "none",
        outlineOffset: "-2px",
        cursor: "pointer",
      })}
      onClick={onSelect}
    >
      <Box p={"md"} bg={UTILITY_COLOR.TABLE_ROW_BACKGROUND}>
        <DFSFallbackImage src={imageUrl} height={154} withPlaceholder />
      </Box>
      <Divider />
      <Box p="md">
        <Group>
          <Stack
            spacing={0}
            sx={{
              flexGrow: 1,
              flexBasis: 0,
              overflow: "hidden",
            }}
          >
            <Text
              fw={WEIGHT_BOLD}
              size="sm"
              title={title}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {title}
            </Text>
            {subtitle && (
              <Text
                size="xs"
                title={subtitle}
                sx={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {subtitle}
              </Text>
            )}
          </Stack>
          {isSelected && (
            <Box
              sx={{
                overflow: "visible",
                display: "flex",
                height: 8,
                alignItems: "center",
              }}
            >
              <CheckCircle />
            </Box>
          )}
        </Group>
      </Box>
    </Box>
  );
};

export default ItemGridTile;
